import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card } from "antd";
import { EditForm } from "../../../components/editForm";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { DEFAULT_QUERY_DATA, generateQueryFormConfig, generateTableColumns } from "./config";
import { AmountServer } from "../../../server";
import { Operation } from "./operation";
import dayjs from "dayjs";

const server = AmountServer.Withdrawal

export const Withdrawal = () => {
    const operationRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({});
    }, []);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, loading, setLoading, refresh });
    }, [operationRef, loading, setLoading, refresh]);

    const formatQueryDate = () => {
        let { AuditAtStart, AuditAtEnd, CreatedAtStart, CreatedAtEnd, ...otherData } = queryData;
        const format = 'YYYY-MM-DD HH:mm:ss'
        AuditAtStart = AuditAtStart ? dayjs(AuditAtStart).startOf('day').format(format) : null;
        AuditAtEnd = AuditAtEnd ? dayjs(AuditAtEnd).endOf('day').format(format) : null;
        CreatedAtStart = CreatedAtStart ? dayjs(CreatedAtStart).startOf('day').format(format) : null;
        CreatedAtEnd = CreatedAtEnd ? dayjs(CreatedAtEnd).endOf('day').format(format) : null;
        return { ...otherData, AuditAtStart, AuditAtEnd, CreatedAtStart, CreatedAtEnd };
    };

    return (
        <div>
            <Card>
                <EditForm
                    componentId="recharge-query-form"
                    loading={loading}
                    formAttrsProps={{
                        layout: 'inline',
                    }}
                    formData={queryData}
                    onDataChange={setQueryData}
                    formConfig={getQueryFormConfig}
                    onQuery={() => {
                        run({ ...DEFAULT_PAGE_DATA, ...formatQueryDate() });
                    }}
                    onReset={() => {
                        setQueryData({ ...DEFAULT_QUERY_DATA });
                        run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                    }}
                />
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...formatQueryDate() });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}